export default {
  metaTitle: 'Manage Platform Coin Plans',
  pageTitle: 'Manage Platform Coin Plans',
  region: 'Region',
  content1: 'The current Coins deduction parameters of Kilimall, the deduction ratio is',
  content2: 'and the deduction limit is',
  content3: 'I am willing to join the Kilimall Coins redemption program',
  content4: 'Please understand the content and it is irreversible operation after confirm',
  content5: 'Kilimall Coins redemption plan',
  main1: 'Kilimall opens the Coins deduction function to users in order to promote the stores and Kilimall. Users can use Coins to make payment deduction.',
  main2: 'The deduction ratio and the upper limit are managed by the Kilimall. Generally, the ratio (excluding the freight amount in the order) is',
  main3: 'and the upper limit is',
  main4: 'Deduction ratio may be dynamically adjusted during the promotion period.',
  main5: 'After accepting the terms, all the items in your current store will support Kilimall Coins redemption and will show to the user on the product details page.',
  main6: 'Afteraccepting the terms, Kilimall will afford {discount}% of the Kilimall Coins that user has redeemed with the completed order.',
  main7: 'If you have not join the program, it will be shown in the details of all products in your store.',
  main8: 'The agreement is irreversible after you agree it, please submit it carefully.',
  confirmTitle: '提交后不能取消，您确定要提交吗?',
  okText: '确定',
  cancelText: '取消',
  success: '提交成功',
  error: '请勾选协议'
}
